import React, { useState, useEffect, Component } from 'react';
import { NavLink as NavLinkRRD, Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
//import axios from "axios";
import axiosInstance from './../../helpers/axiosInstance';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Skeleton from 'react-loading-skeleton';
import iconDetails from '../../assets/img/icons/Icono-Detalles-Blanco.png';
import iconTransfer from '../../assets/img/icons/Icono-Transferencia-Blanco.png';
import iconPay from '../../assets/img/icons/Icono-Pago-Interno-Blanco.png';
import iconProyect from '../../assets/img/icons/Icono-Deuda-Blanco.png';
import { useSelector, useDispatch } from 'react-redux';
import { actualizaProductSelect } from '../../Slicersreducers';

// reactstrap components
import {
  Card,
  Button,
  NavLink,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  CardTitle,
  UncontrolledTooltip,
} from 'reactstrap';
import Botonrapido from './botonaccionesrapidas.js';

const Movimientoshome = (props) => {
  const dispatch = useDispatch();
  var createReactClass = require('create-react-class');
  const [isMovementLoading, setisMovementLoading] = useState(true);
  const [product, setproduct] = useState(props.product);
  const [shortcutAccount, setshortcutAccount] = useState(props.shortcutAccount);
  const [shortcutLoan, setshortcutLoan] = useState(props.shortcutLoan);
  const [shortcutCdt, setshortcutCdt] = useState(props.shortcutCdt);
  const [listMovements, setlistMovements] = useState([]);
  const ListProductsHome = useSelector((state) => state.miga.listProductsHome);
  const ProductSelct = useSelector((state) => state.miga.ProductSelect);
  useEffect(() => {
    if (ListProductsHome.legth > 0) {
      setisMovementLoading(true);
    } else {
      setisMovementLoading(false);
    }
  }, [ListProductsHome, product]);

  // const getProductListSelect = () => {
  //   let listProductSelect = [];
  //   ListProductsHome.map((item, index) => {
  //     listProductSelect.push(false);
  //   });
  //   console.log('cristal' + ListProductsHome);
  //   dispatch(actualizaProductSelect(listProductSelect));
  // };
  var Movements = (props) => {
    var data = props.data;
    var newsTemplate;
    var title;
    setproduct(props.producto);
    if (data != null) {
      if (isMovementLoading) {
        newsTemplate = (
          <div>
            <Skeleton
              height={80}
              count={4}
              className="card-transaction-info"
              style={{ width: '-webkit-fill-available' }}
            ></Skeleton>
          </div>
        );
      } else {
        newsTemplate = data.map(function (item, index) {
          return (
            <div key={index}>
              <Movement
                data={item}
                getProductSelect={props.getProductSelect}
                i={index}
              />
            </div>
          );
        });
      }
    } else {
      newsTemplate = <p>Hoy no se han generado movimientos</p>;
    }

    if (product.accountNumber === undefined) title = '';
    else
      title = (
        <h1
          className="text-black mb-3"
          style={{ 'padding-left': '45px', fontSize: '20px' }}
        >
          Movimientos Producto Número: {props.producto.accountNumber}
        </h1>
      );
    return (
      <div style={{ fontWeight: 'bold' }}>
        {/* {title} */}
        {newsTemplate}
      </div>
    );
  };

  const formatearNumeroConComas = (numero) => {
    const numeroSinComas = numero.replace(/,/g, '');
    if (/^\d+$/.test(numeroSinComas)) {
      return numeroSinComas.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } else {
      return numero;
    }
  };

  var Movement = createReactClass({
    render: function () {
      let cuentaSupervision = '';
      var Description = this.props.data.description,
        Account = this.props.data.accountNumber,
        Value = formatearNumeroConComas(this.props.data.balance),
        color =
          this.props.data.sign === '' || this.props.data.sign === undefined
            ? 'text-grissantander'
            : this.props.data.sign === '+'
            ? 'text-green'
            : 'text-primary';

      console.log('Value: ' + Value);
      if (
        this.props.data.accountType === '1' ||
        this.props.data.accountType === '2'
      ) {
        cuentaSupervision = Description.substring(
          Description.length - 1,
          Description.length
        );
        Description = Description.substring(0, Description.length - 1).trim();
        if (Description === '') {
          Description = 'CUENTA VISTA/ CONVENIOS';
        }
      }
      return (
        <div
          className="card-transaction-info ml-5 mr-5"
          style={
            ProductSelct[this.props.i]
              ? { border: '2px solid #28d239', marginBottom: '20px' }
              : {
                  marginBottom: '20px',
                }
          }
          onClick={() =>
            this.props.getProductSelect(this.props.data, this.props.i)
          }
        >
          <Row style={{ alignItems: 'center' }}>
            <div className="col">
              <Row>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: 20 + 'px',
                  }}
                >
                  <p
                    style={{
                      fontWeight: 700,
                      margin: '2px 0 0 0px',
                      fontSize: '12px',
                    }}
                  >
                    {Description}
                  </p>
                </div>
              </Row>
              <Row>
                <span
                  style={{ marginBottom: 0, marginLeft: '20px' }}
                  class="mb-2 text-sm"
                >
                  N° de Producto: {Account}
                </span>
              </Row>
            </div>
            <div
              style={{
                display: 'grid',
                gridTemplateRows: '40% 40%',
                gridTemplateColumns: '1fr',
              }}
            >
              {cuentaSupervision === 'S' ? (
                <Row style={{ gridRow: '1' }}>
                  {' '}
                  <div className="col-auto mr-3 vertical-center">
                    <h6 class="mb-2 text-sm">Cuenta con Supervisión</h6>
                  </div>
                </Row>
              ) : (
                ''
              )}
              <Row style={{ gridRow: '2' }}>
                <div className="col-auto mr-3 vertical-center">
                  <h6 class="mb-2 text-sm">
                    Disponible:{'  '}
                    <i
                      className="fas fa-dollar-sign"
                      style={{ marginRight: '4px', marginLeft: '4px' }}
                    />
                    {Value}
                    <span class="decimal-numbers-format"></span>
                  </h6>
                </div>
              </Row>
            </div>
          </Row>
        </div>
      );
    },
  });

  var ShortCuts = createReactClass({
    render: function () {
      var product = this.props.data;
      var newsTemplate;
      if (product != null) {
        if (!isMovementLoading) {
          var vec = shortcutAccount;
          if (product.accountType === '3' || product.accountType === '6') {
            vec = shortcutLoan;
          } else if (product.accountType === '7') {
            vec = shortcutCdt;
          }
          newsTemplate = vec.map(function (item, index) {
            return <ShortCut data={item} producto={product} key={index} />;
          });
        } else {
          newsTemplate = (
            <>
              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>

              <Col xl="2" md="4" sm="12" className="">
                <Skeleton height={100} className="card-fast-actions"></Skeleton>
              </Col>
            </>
          );
        }
      } else {
        newsTemplate = <p>Hoy no se han generado movimientos</p>;
      }
      //return <Row className="mt-1">{newsTemplate}</Row>;
      return (
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
          }}
        >
          {newsTemplate}
        </Col>
      );
    },
  });

  var ShortCut = createReactClass({
    render: function () {
      var icon = this.props.data.icon,
        iconactiv = this.props.data.iconactiv,
        title = this.props.data.title,
        path = this.props.data.path,
        state = this.props.data.state,
        producto = this.props.producto;
      //
      return (
        <NavLink
          to={{
            pathname: path,
            state: {
              accountNumber: producto.accountNumber,
              accountType: producto.accountType,
              system: producto.system,
              balance: producto.balance,
            },
          }}
          tag={NavLinkRRD}
          activeClassName="active"
        >
          <Botonrapido
            icon={icon}
            title={title}
            iconactiv={iconactiv}
          ></Botonrapido>
        </NavLink>
      );
    },
  });

  return (
    <Col
      xl="12"
      md="12"
      sm="12"
      style={{ display: 'grid', gridTemplateColumns: '8fr 1fr' }}
    >
      <div>
        <h2 style={{ marginLeft: '48px' }}>
          Producto Número: {product.accountNumber}
        </h2>
        <div
          style={{
            position: 'relative',
            overflow: 'auto',
            height: '40vh',
            width: '100%',
          }}
        >
          <Movements
            data={ListProductsHome}
            producto={props.product}
            getProductSelect={props.getProductSelect}
          ></Movements>
        </div>
      </div>
      <ShortCuts data={product}></ShortCuts>
    </Col>
  );
};

export default Movimientoshome;
